// Ostoskorin upsellin "+ Lisää"-napit (snippets/3dp-cart-upsell.liquid).
// Ladataan cart-drawer.liquidista aina sivun mukana: upsell-markup tulee draweriin usein vasta
// AJAX-päivityksessä (kori tyhjä sivun latautuessa), eikä sellaisen mukana tullut inline-skripti suoritu.
import { CartLinesUpdateEvent } from '@shopify/events';

document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element && event.target.closest('[data-dp-upsell-add]');
  if (!button || button.disabled) return;

  event.preventDefault();
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');

  const variantId = button.dataset.dpUpsellAdd;
  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
  const deferred = CartLinesUpdateEvent.createPromise();

  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: variantId, quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    }).then((res) => res.json());

    if (response.status) throw new Error(response.description || response.message);

    const cart = await fetch(`${Theme.routes.cart_url}.js`).then((res) => res.json());

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: '3dp-cart-upsell',
        itemCount: 1,
        sections: response.sections,
        didError: false,
      },
    });
  } catch (error) {
    deferred.reject(error);
    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.textContent = 'Ei lisätty';
  }
});
